import { render, staticRenderFns } from "./StoreCardSkeleton.vue?vue&type=template&id=e2f211a6&scoped=true"
import script from "./StoreCardSkeleton.vue?vue&type=script&lang=js"
export * from "./StoreCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./StoreCardSkeleton.vue?vue&type=style&index=0&id=e2f211a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f211a6",
  null
  
)

export default component.exports